export enum AppPermissionStatus {
    GRANTED = 'granted',
    DENIED = 'denied',
    PROMPT = 'prompt'
  }
  